import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  AdminBriefApplicationCleanupDeleteResult,
  AdminBriefApplicationCleanupLookup,
} from '../molecules/brief-application-cleanup/brief-application-cleanup.types';

@Injectable({
  providedIn: 'root',
})
export class AdminBriefApplicationCleanupService {
  private http = inject(HttpClient);

  lookup(briefId: string, creatorId: string): Observable<AdminBriefApplicationCleanupLookup> {
    const url = `${environment.shout_api.url}/brief-application/admin/cleanup-lookup/${briefId}/${creatorId}`;
    return this.http.get<AdminBriefApplicationCleanupLookup>(url);
  }

  deleteApplication(
    applicationId: string,
    creatorId: string,
  ): Observable<AdminBriefApplicationCleanupDeleteResult> {
    const url = `${environment.shout_api.url}/brief-application/admin/cleanup/${applicationId}/${creatorId}`;
    return this.http.delete<AdminBriefApplicationCleanupDeleteResult>(url);
  }
}
